<template>
    <div id="confirmLogout" class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-centered justify-content-center" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h3 class="popup-title">{{ $t('logout') }}</h3>
                    <i class="close-popup" data-bs-dismiss="modal" aria-label="Close"></i>
                </div>
                <div class="modal-body text-center">
                    <p class="txt-popup">{{ $t('logout_confirm') }}</p>
                </div>
                <div class="modal-footer">
                    <div class="ito-btn-small" data-bs-dismiss="modal">
                        {{ $t('no') }}
                    </div>
                    <div class="ito-btn-small active" @click="onLogout()">
                        {{ $t('yes') }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "LogoutModal",

    methods: {
        onLogout(e) {
            window.boChatbot?.newSession()
            this.$store.commit("setLoading", true);
            this.$store.dispatch('logout').then(() => {
                document.cookie = `_wid=; expires=Thu, 01 Jan 1970 00:00:00 UTC,  path=/`;
                localStorage.removeItem('is_login');
                localStorage.removeItem('banner_hidden');
                window.location.href = "/login";
            });
            // e.preventDefault();
        },
    }
}
</script>

<style scoped>
#confirmLogout .modal-content {
    max-width: 326px;
    padding: 20px;
    border-radius: 25px;
    box-shadow: 0px 4px 0px 0px rgba(231, 231, 231, 0.25) inset;
}

#confirmLogout .modal-content .modal-header {
    padding: 0;
    border: none;

}

#confirmLogout .modal-content .modal-header .popup-title {
    color: #000;
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
}

#confirmLogout .modal-content .modal-body,
#confirmLogout .modal-content .modal-footer {
    padding: 0;
    margin-top: 20px;
}

#confirmLogout .modal-content .modal-footer {
    justify-content: center;
    gap: 10px;
    border: none;
}

#confirmLogout .modal-content .modal-body .txt-popup {
    color: #070A28;
    text-align: center;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: 0.24px;
}

#confirmLogout .modal-content .ito-btn-small {
    width: 110px;
    height: 26px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #FFF;
    text-align: center;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: 14px;
    letter-spacing: 0.24px;
    border-radius: 30px;
    background: linear-gradient(180deg, #CBCBCB 0%, #B2B2B2 100%);
    box-shadow: 0px 2px 0px 0px rgba(255, 255, 255, 0.20) inset, 4px 4px 0px 0px rgba(0, 0, 0, 0.07);
}

#confirmLogout .modal-content .ito-btn-small.active {
    background: linear-gradient(180deg, #45BCFF 0%, #00A3FF 100%);
}

#confirmLogout .modal-content .close-popup {
    width: 24px;
    height: 24px;
    top: 10px;
    right: 10px;
    background-size: 75%;
    background-position: center;
}</style>
